import React, { useState, useEffect } from 'react';
import { TextInput } from '@wajeez-web/components/ui';
import { Modal, Button } from '@wajeez-web/components/ui';
import { PlusIcon } from '@heroicons/react/solid';
import { WajeezList, WajeezRow } from '@wajeez-web/components/list-builder';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { useAppDispatch } from '@wajeez-web/stores/base';
import {
  ReportProblemActions,
  useCustomerSelector,
} from '@wajeez-web/stores/customers';

const ProblemOptionsModal: React.FC<CommonModalProps<void>> = ({
  isOpen,
  onClose,
}) => {
  const { options, optionStatus } = useCustomerSelector(
    (state) => state.reportProblem
  );
  const [newOption, setNewOption] = useState('');
  const dispatch = useAppDispatch();
  const getOptions = () => {
    dispatch(ReportProblemActions.getAllReportProblemOptionsAsync());
  };
  return (
    <Modal
      withScroll={true}
      title={'Report Problem Options'}
      open={isOpen}
      onClose={onClose}
    >
      <div className="overflow-y-auto  scrollbar-thin scrollbar-thumb-gray-400 space-y-2 ">
        <TextInput
          suffix={
            <Button
              shape="circle"
              disabled={!newOption}
              Icon={PlusIcon}
              onClick={async () => {
                const res = await dispatch(
                  ReportProblemActions.createReportProblemOptionAsync({
                    languageId: 1,
                    text: newOption,
                  })
                );
                if (res.meta.requestStatus === 'fulfilled') {
                  setNewOption('');
                  getOptions();
                }
              }}
            />
          }
          value={newOption}
          name="newOption"
          onChange={(_, val) => setNewOption(val)}
          label="New Option"
        />
        <div className="overflow-y-auto  scrollbar-thin scrollbar-thumb-gray-400  ">
          <WajeezList
            isLoading={optionStatus === 'loading'}
            gridItems={1}
            data={options}
            keyExtractor={(item) => item.id + ''}
            renderItem={(item) => (
              <WajeezRow
                key={item.id}
                title={item.text}
                headerActions={[
                  {
                    type: 'action',
                    label: 'Delete',
                    onClick: async () => {
                      const res = await dispatch(
                        ReportProblemActions.deleteReportProblemOptionAsync(
                          item.id || 0
                        )
                      );
                      if (res.meta.requestStatus === 'fulfilled') {
                        getOptions();
                      }
                    },
                  },
                ]}
              />
            )}
            containerType="cards"
            getData={getOptions}
          />
          {/* <ListBuilder
                isLoading={loadList}
                data={problemOptions}
                showAs="rows"
                addAction={[
                  {
                    type: 'input',
                    name: 'Add Option',

                    placeholder: 'Option Name',
                    addItem: (text) => {
                      // ReportProblemServices.createNewReportProblemOptions(text);
                    },
                  },
                ]}
                getData={() => {}}
                onDelete={(i) => {
                  // ReportProblemServices.deleteReportProblemOptionById(
                  //   Number(problemOptions[i]?.id),
                  //   t
                  // );
                }}
                listEndpoint="assignAuthors"
                rowActions={[
                  {
                    type: 'delete',
                    showAs: null,
                    permission: AdminSystemPermissions.reportProblem.delete,
                  },
                ]}
              /> */}
        </div>
      </div>
    </Modal>
  );
};

export default ProblemOptionsModal;
